// src/pages/NotFoundPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import './css/N404.css'
import Header from './Header';
import Banner from './Banner';


function N404() {
    return (
        <>
            <Header/>
            <Banner/>
            <div className="container-404">

                <h1>404</h1>
                <p>Ups! Táto stránka neexistuje.</p>
                <Link to="/" className="home-link">
                    Domov
                </Link>
            </div>
        </>
    );
}

export default N404;
